import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/**
 * Icon button that copies `value` to the clipboard.
 *
 * Same approach as coupons/CodeChip.js: `navigator.clipboard` needs a secure context, so plain http
 * (the dev server) falls back to a hidden textarea. That component is styled for the `cpn-` build,
 * so it can't be reused here.
 */
const CopyButton = ({ value, label }) => {
    const [copied, setCopied] = useState(false);

    if (!value) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (err) {
            const helper = document.createElement('textarea');
            helper.value = value;
            document.body.appendChild(helper);
            helper.select();
            document.execCommand('copy');
            document.body.removeChild(helper);
        }

        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
    };

    return (
        <button
            type="button"
            onClick={copy}
            title={`Copy ${label}`}
            aria-label={`Copy ${label}`}
            className="tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-p-0.5 tw-text-neutral-400 hover:tw-text-neutral-700 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-300"
        >
            {copied
                ? <Check className="tw-h-3.5 tw-w-3.5 tw-text-green-600" aria-hidden="true" />
                : <Copy className="tw-h-3.5 tw-w-3.5" aria-hidden="true" />}
            <span className="tw-sr-only" role="status">{copied ? 'Copied' : ''}</span>
        </button>
    );
};

export default CopyButton;
